module.exports = __webpack_public_path__ + "static/media/drone404.233e026e.jpg";